<template lang="pug">
  b-modal#updatePTSL(
    ref="updatePTSL"
    :title="$t('ui.combine.update_position_taking')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="xl"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}] 
      #tblModal.table-sm.table-responsive
        table.table.table-bordered(v-if="$store.getters.getPTSL")
          thead
            tr
              th(colspan=2) {{ $t("ui.sport_types") }}
              th.text-center(style="width:15%;")
                span {{ $helpers.getUplineName($store.getters.accountType) }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                span {{ $helpers.getUplineName($store.getters.accountType - 1) }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                span {{ $t("ui.remaining") }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                span {{ $t("ui.min") }}
          ptTableRowSlots(ref="ptTableRowSlots" :loading="!$helpers.getVisible(editLimit)")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import ptTableRowSlots from "@/components/positionTaking/ptTableRowSlots.vue";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    ptTableRowSlots,
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      ptJSON: {
        slots_upline_pt: 0,
        slots_account_pt: 0,
        slots_upline_remaining: 0,
        slots_account_min: 0
      },
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {},
  computed: {
    editLimit() {
      return [config.accessRoles.editLimit]
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    isValidForm() {
      this.$refs.ptTableRowSlots.$v.$touch()
      return this.$refs.ptTableRowSlots.$v.$invalid
    },
    formPtJson: function() {
      let allRefs = this.$refs
      for (var refType in allRefs) {
        let refList = this.$refs[refType].$refs
        for(var ref in refList) {
          this.ptJSON[ref] = this.$refs[refType][ref]
        }
      }
    },
    getChildPositionTaking: function() {
      // $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "SLOTS"
      if(account_id) {
        this.$store
        .dispatch("user/getChildPositionTaking", { account_id, platform_code })
        .then(response => {
          this.$refs.ptTableRowSlots.$v.slots_upline_pt.$model = response.data.pt[0].upline_pt
          this.$refs.ptTableRowSlots.$v.slots_account_pt.$model = this.$helpers.isAgentLevel() ? 0 : response.data.pt[0].account_pt
          this.$refs.ptTableRowSlots.$v.slots_upline_remaining.$model = this.$helpers.isAgentLevel() ? 0 : response.data.pt[0].upline_remaining
          this.$refs.ptTableRowSlots.$v.slots_account_min.$model = this.$helpers.isAgentLevel() ? 0 : response.data.pt[0].account_min
          // $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
          // console.log("Failed:getChildPositionTaking", response)
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      if (!this.isValidForm()) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_position_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updatePositionTakingSL()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_position_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updatePositionTakingSL: function() {
      this.formPtJson()
      let account_id = this.accountId
      let pt = this.ptJSON
      this.$store
        .dispatch("user/updatePositionTakingSL", { account_id, pt })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_position_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updatePositionTakingSL", response)
          this.loading = false;
          this.submission.success = response.success
          // this.submission.status = this.$t("message." + response.errorTag)
          if(response.errorTag.indexOf(' ') >= 0 ) {
            var oldTime = this.$moment(response.errorTag).format("YYYY-MM-DD HH:mm:ss")
            var newTime = this.$moment(response.errorTag).add(24, "hours").format("YYYY-MM-DD HH:mm:ss")
            this.submission.status = this.$t("message.last_modified_slot", {"oldTime" : oldTime, "newTime" : newTime})
          } else {
            this.submission.status = this.$t("message." + response.errorTag)
          }
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getPositionTaking()
        this.getChildPositionTaking()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updatePTSL.hide()
    }
  }
};
</script>

